module.exports = __webpack_public_path__ + "img/telcom_bsp.7a20dbc3.png";